'use strict';
define([
	'./GetDifferentData',
	'./AnalysisDifferentData',
	'../../../base/PureComponent'
], function(GetDifferentData, AnalysisDifferentData, PureComponent) {
    /**
     * @constructor
     * @classdesc 标绘同步组件
     * @augments G.base.PureComponent
     * @alias G.plot.PlotSyncComponent
     * @param options {Object} 必填
     * @param options.map {G.Map} 必填，地图对象
     * @param options.matchingLayer {Array} 必填,正则表达式匹配图层 例如：{ 'dataLayer': [/^visualize-/], 'plotLayer': [/^plot/] }
     */
	var plotSyncCtrl = PureComponent.extend({
		options: {
			title: '标绘同步接口类'
		},
		initialize: function(options) {
			PureComponent.prototype.initialize.call(this, options);
			this._getDifferentData = new GetDifferentData(options);
			this._analysisDifferentData = new AnalysisDifferentData(options);
		},
		/*
		 * 销毁，对应initialize
		 * */
		destroy: function() {
			//销毁获取数据的类
			try {
				this._getDifferentData.destroy();
			} catch(e) {}
			//销毁解析数据的类
			try {
				this._analysisDifferentData.destroy();
			} catch(e) {}
			//销毁控件
			PureComponent.prototype.destroy.call(this);
		}
	})
	/**
	 * 获取数据的接口
	 * */
	plotSyncCtrl.include({
        /**
         * 获取地图视野的参数
         * @method
         * @memberOf G.plot.PlotSyncComponent.prototype
         * @return mapViewJson {Object} 地图视野参数对象
         */
		viewSyncGetData: function() {
			var mapViewJson = this._getDifferentData.getMapView();
			return mapViewJson;
		},
        /**
         * 获取传入匹配图层的标绘数据
         * @method
         * @memberOf G.plot.PlotSyncComponent.prototype
         * @return plotDataJson {Object} 各个图层对应的标绘数据集合
         */
		plotSyncGetData: function() {
			var plotDataJson = this._getDifferentData.getPlotData();
			return plotDataJson;
		},
        /**
         * 获取传入匹配图层的可视化数据
         * @method
         * @memberOf G.plot.PlotSyncComponent.prototype
         * @return syncDataJson {Object} 各个图层对应的可视化数据集合
         */
		dataSyncGetData: function() {
			var syncDataJson = this._getDifferentData.getSyncData();
			return syncDataJson;
		}
	})
	/**
	 * 解析视野同步的接口
	 * */
	plotSyncCtrl.include({
        /**
         * 解析视野数据
         * @method
         * @memberOf G.plot.PlotSyncComponent.prototype
         * @param options {Object} 必填
         * @param options.data {Object} 必填 中心点和地图的缩放等级
         */
		viewSyncShowData: function(options) {
			var boolean = false;
			if(!!options) {
				if(options.data) {
					var msg = "";
					try {
						msg = this._analysisDifferentData.analysisMapView(options.data);
						boolean = true;
					} catch(e) {
						msg = e.message;
						boolean = false;
					} finally {}
				}
			}
			return boolean;
		}
	})
	/**
	 * 数据解析和操作的接口
	 * */
	plotSyncCtrl.include({
        /**
         * 解析可视化数据
         * @method
         * @memberOf G.plot.PlotSyncComponent.prototype
         * @param options {Object} 必填
         * @param options.data {Object} 必填 解析可视化数据展示到地图上
         * @param options.memberId {String} 必填 需要解析数据用户的唯一标识
         * @return opts {Object} 返回解析本次数据的消息 {msg:'',dataId:'本次解析数据的id'}
         */
		dataSyncShowData: function(options) {
			var opts = {};
			if(!!options) {
				try {
					opts = this._analysisDifferentData.analysisSyncData(options);
				} catch(e) {
					opts.msg = e.message;
				} finally {}
			}
			return opts;
		},
        /**
         * 清除某用户或者所有用户的数据
         * @method
         * @memberOf G.plot.PlotSyncComponent.prototype
         * @param options {Object} 必填
         * @param options.memberId {String} 可选 需要清除数据用户的唯一标识，不填默认清除所有
         */
		dataSyncClearData: function(options) {
			var msg = "";
			var boolean = false;
			try {
				if(!!options) {
					var memberId = options.memberId || options.userId
					msg = this._analysisDifferentData.clearSpecifyOrAllData(memberId);
				} else {
					msg = this._analysisDifferentData.clearSpecifyOrAllData();
				}
				boolean = true;
			} catch(e) {
				msg = e.message;
				boolean = false;
			} finally {}
			return boolean;
		},
        /**
         * 显示或隐藏某用户的数据
         * @method
         * @memberOf G.plot.PlotSyncComponent.prototype
         * @param options {Object} 必填
         * @param options.memberId {String} 可选 需要显/隐数据用户的唯一标识，不填默认显/隐所有
         * @param options.visible {Boolean} 必填 true显示 false隐藏
         */
		dataSyncSetVisiblity: function(options) {
			var msg = "";
			var boolean = false;
			try {
				if(!!options) {
					var memberId = options.memberId || options.userId;
					var visible = options.visible || true;
					msg = this._analysisDifferentData.visibleSpecifyOrAllData(memberId, visible);
					boolean = true;
				}
			} catch(e) {
				msg = e.message;
				boolean = false;
			} finally {}
			return boolean;
		},
        /**
         * 根据数据id查询展示数据
         * @method
         * @memberOf G.plot.PlotSyncComponent.prototype
         * @param options {Object} 必填
         * @param options.memberId {String} 必填 展示数据用户的唯一标识
         * @param options.dataId {String} 必填 解析数据返回的对应的唯一id
         */
		querySyncDataById: function(options) {
			var boolean = false;
			try {
				if(!!options) {
					this._analysisDifferentData.querySyncDataById(options);
					boolean = true;
				}
			} catch(e) {
				boolean = false;
			}
			return boolean;
		}
	});
	/**
	 * 解析和操作数据的接口
	 * */
	plotSyncCtrl.include({
        /**
         * 解析标绘的数据
         * @method
         * @memberOf G.plot.PlotSyncComponent.prototype
         * @param options {Object} 必填
         * @param options.data {Object} 必填 解析标绘数据展示到地图上
         * @param options.memberId {String} 需要解析标绘数据用户的唯一标识
         * @return opts {Object} 返回解析本次数据的消息 {msg:'',dataId:'本次解析数据的id'}
         */
		plotSyncShowData: function(options) {
			var opts = {};
			if(!!options) {
				try {
					opts = this._analysisDifferentData.analysisSyncPlot(options);
				} catch(e) {
					opts.msg = e.message;
				} finally {}
			}
			return opts;
		},
        /**
         * 清除某用户或者所有用户的标绘
         * @method
         * @memberOf G.plot.PlotSyncComponent.prototype
         * @param options {Object} 必填
         * @param options.memberId {String} 可选 需要清除数据用户的唯一标识，不填默认清除所有
         */
		plotSyncClearData: function(options) {
			var msg = "";
			var boolean = false;
			try {
				if(!!options) {
					var memberId = options.memberId || options.userId
					msg = this._analysisDifferentData.clearSpecifyOrAllPlot(memberId);
				} else {
					msg = this._analysisDifferentData.clearSpecifyOrAllPlot();
				}
				boolean = true;
			} catch(e) {
				msg = e.message;
				boolean = false;
			} finally {}
			return boolean;
		},
        /**
         * 显示或隐藏某用户的数据
         * @method
         * @memberOf G.plot.PlotSyncComponent.prototype
         * @param options {Object} 必填
         * @param options.memberId {String} 可选 需要显/隐数据用户的唯一标识，不填默认显/隐所有
         * @param options.visible {Boolean} 必填 true显示 false隐藏
         */
		plotSyncSetVisiblity: function(options) {
			var msg = "";
			var boolean = false;
			try {
				if(!!options) {
					var memberId = options.memberId || options.userId;
					var visible = options.visible || true
					msg = this._analysisDifferentData.visibleSpecifyOrAllPlot(memberId, visible);
					boolean = true;
				}
			} catch(e) {
				msg = e.message;
				boolean = false;
			} finally {}
			return boolean;
		},
        /**
         * 根据标绘数据id查询展示数据
         * @method
         * @memberOf G.plot.PlotSyncComponent.prototype
         * @param options {Object} 必填
         * @param options.memberId {String} 必填 展示数据用户的唯一标识
         * @param options.dataId {String} 必填 解析数据返回的对应的唯一id
         */
		queryPlotDataById: function(options) {
			var boolean = false;
			try {
				if(!!options) {
					this._analysisDifferentData.queryPlotDataById(options);
					boolean = true;
				}
			} catch(e) {
				boolean = false;
			}
			return boolean;
		}
	})
	return plotSyncCtrl;
})